/**
 * VERSIONE LIBRERIA 3
 */
var RenderDate = Render.extend({
    year_selector    : '[data-render_year]',
    month_selector    : '[data-render_month]',
    day_selector    : '[data-render_day]',
    picker_selector : '[data-render_picker]',
    type : 'date',
    classData : 'date',
    classTemplate : 'date',
    format : 'numeric',
    operator : null,
    active : ['day','month','year'],
    startYear : null,
    endYear : null,
    dateType : 'select',

    _getTemplate : function () {
        var self = this;
        var tplId = self.templateId;
        if (!tplId) {
            if (self.mode == BaseElement.VIEW) {
                tplId = '#' + self.prefixTemplateClass + "_" + self.classTemplate + "_" + self.mode + "_tpl";
                if ($(tplId).length == 0)
                    throw "Template source " + tplId + " Not found";
            }
            else {
                tplId = '#'+self.prefixTemplateClass+"_"+self.classTemplate+"_"+self.dateType+"_tpl";
                if ($(tplId).length == 0)
                    throw "Template source " + tplId + " Not found";

            }
        }
        return $.createDynamicContainer(tplId);
    },


    _renderView : function (jQe) {
        var self = this;
        var value = self.value;
        if (value && value.length > 10) {
            value = value.replace(" ","T");
        }

        var timestamp=Date.parse(value);

        if (isNaN(timestamp)==false)
        {
            var d=new Date(timestamp);
            value = d.toLocaleDateString($.locale,$.cupparisDateFormat(self.format));

        } else {
            value = self.invalidDateString?self.invalidDateString:'';

        }


        var el = jQe.find(self.element_selector);
        el.html(value);

    },
    _renderEdit : function(jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("name", self.key).attr('value',self.value);
        self._setDateControl(jQe);
    },
    _renderSearch : function(jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("name", 's_' + self.key + '[]').attr("value", self.value);
        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + "_operator",
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
        self._setDateControl(jQe);
    },

    _setDateControl : function (jQe) {
        var self = this;
        var active = self.active?self.active:['day','month','year'];
        var currentYear = parseInt(new Date().getFullYear());
        var startYear = self.startYear ? self.startYear : currentYear - 30;
        var endYear = self.endYear ? self.endYear : currentYear + 10;
        if (self.dateType == "select") {
            //DAY
            var elD = jQe.find(self.day_selector);

            //NO VALUE
            var opt = $('<option>').attr({
                value : ''
            });
            opt.html($.translate('general-giorno'));
            elD.append(opt);

            for (var i=1;i<=31;i++) {
                i = Utility.padDate(i, 2)
                var opt = $('<option>').attr({
                    value : i
                });
                opt.html(i);
                elD.append(opt);
            }
            if ($.inArray('day',active) < 0) {
                jQe.find('[data-render_day_container]').addClass('hide');
                elD.addClass('hide');
            }

            //MONTH
            var elM = jQe.find(self.month_selector);
            //NO VALUE
            var opt = $('<option>').attr({
                value : ''
            });
            opt.html($.translate('general-mese'));
            elM.append(opt);

            for (var i=1;i<=12;i++) {
                i = Utility.padDate(i, 2)
                var opt = $('<option>').attr({
                    value : i
                });
                opt.html(i);
                elM.append(opt);
            }
            if ($.inArray('month',active) < 0) {
                jQe.find('[data-render_month_container]').addClass('hide');
                elD.addClass('hide');
            }

            //YEAR
            var elY = jQe.find(self.year_selector);
            //NO VALUE
            var opt = $('<option>').attr({
                value : ''
            });
            opt.html($.translate('general-anno'));
            elY.append(opt);

            for (var i=endYear;i>startYear;i--) {
                var opt = $('<option>').attr({
                    value : i
                });
                opt.html(i);
                elY.append(opt);
            }
            if ($.inArray('year',active) < 0) {
                jQe.find('[data-render_year_container]').addClass('hide');
                elD.addClass('hide');
            }
        } else if (self.dateType == "picker") {
            //var el = obj.find('[data-control_picker]');
            var el = jQe.find(self.picker_selector);
            el.attr("name", self.key + "_picker").attr("value", self.value);

        } else {
            throw "date error subtype " + self.dateType + " undefined";
        }
    },
    _dbDateToArray : function () {
        var self = this;
        if (!self.value)
            return ['','',''];
        var tmpData = self.value;
        if (tmpData.indexOf(' ') >= 0) {
            tmpData = tmpData.split(' ')[0];
        }
        if (tmpData.indexOf('T') >= 0) {
            tmpData = tmpData.split('T')[0];
        }

        var sdate = tmpData.split("-");
        if (sdate[1] && sdate[1].length == 1) {
            sdate[1] = "0"+sdate[1];
        }
        if (sdate[2] && sdate[2].length == 1) {
            sdate[2] = "0"+sdate[2];
        }
        return sdate;
    },
    _changeDate : function () {
        //var options = '<option value="">--</option>';
        var self = this;
        var active = self.active?self.active:['day','month','year'];
        var options = '';
        var year =  $(self.container).find(self.year_selector);
        var month = $(self.container).find(self.month_selector);
        var day =  $(self.container).find(self.day_selector);

        var selected = "";
        var key = self.key;
        var maxDay = 28;
        if (month.val() == '04' || month.val() == '06' || month.val() == '09' || month.val() == '11') {
            maxDay = 30;
        } else if (month.val() != '02') {
            maxDay = 31
        } else if (year.val() % 4 == 0 || year.val() % 100 == 0)
            maxDay = 29;


        for (var i = 1; i <= maxDay; i++) {
            var j = Utility.padDate(i,2);
            if (day.val() == j)
                selected = ' selected="selected" ';
            options += '<option value="' + j + '"' + selected + '>' + j + '</option>';
            selected = '';
        }

        var ex_day = day.val();
        day.empty();
        day.append(options);
        if (ex_day <= maxDay)
            day.val(ex_day);

        var finalDate = $(self.container).find(self.control_selector);//$('input[name="'+key+'"]');
        var d = finalDate.val().split(" ");
        var t = ""; // tempo in caso di campo datetime
        if (d.length > 1)
            t = d[1];

        var date = '';

        //FORZARE YEAR, MONTH E DAY VAL SE NON ATTIVI
        var yearVal = $.inArray('year',active) < 0 ? '0000' : year.val();
        var monthVal = $.inArray('month',active) < 0 ? '00' : month.val();
        var dayVal = $.inArray('day',active) < 0 ? '00' : day.val();
        if (yearVal == '' || monthVal == '' || dayVal == '') {
            date = ''//finalDate.val('');
        } else {
            var date =  yearVal + '-' + monthVal + '-' + dayVal;//finalDate.val(yearVal + '-' + monthVal + '-' + dayVal);
        }
        if (t != "")
            date += ' ' + t;
        finalDate.attr('value',date).val(date);
        return;
    },
    _finalizeView : function() {

    },
    _finalizeSearch : function () {
        var self = this;
        //self._finalizeCommon();
        switch(self.dateType) {
            case 'select':
                self._finalizeEditSelect();
                break;
            case 'picker':
                self._finalizeEditPicker();
                break;
            default:
                throw self.dateType +" dateType invalid";
        }
    },
    _finalizeEdit : function () {
        var self = this;
        //self._finalizeCommon();
        switch(self.dateType) {
            case 'select':
                self._finalizeEditSelect();
                break;
            case 'picker':
                self._finalizeEditPicker();
                break;
            default:
                throw self.dateType +" dateType invalid";
        }
    },
    _finalizeEditPicker : function () {
        var self = this;
        var currentDate = new Date();
        if (self.value)
            currentDate = Utility.jsDate(self.value);
        console.log(currentDate);
        $(self.container).find(self.picker_selector).datepicker({
            autoclose : true,
            format: "dd-mm-yyyy",
        }).on('changeDate', function (ev) {
            var dbDate = Utility.dbDate(ev.date);
            dbDate = dbDate.split(' ')[0];
            $(self.container).find(self.control_selector).val(dbDate);
            //$(this).datepicker('hide');
        });
        $(self.container).find(self.picker_selector).datepicker('setDate',currentDate);

    },
    _finalizeEditSelect : function() {
        var self = this;
        $(self.container).find(self.year_selector+","+self.month_selector+","+self.day_selector).change(function () {
            self._changeDate();
            var sdate = $(self.year_selector).val() + "-" + $(self.month_selector).val() + "-" + $(self.day_selector).val();
        });
        var d = self._dbDateToArray(self.value);
        $(self.container).find(self.year_selector).val(d[0]);
        $(self.container).find(self.month_selector).val(d[1]);
        $(self.container).find(self.day_selector).val(d[2]);
    },
    setValue : function (value) {
        var self = this;
        var container =  self.getContainer();
        var dp = container.find('input[name="' + self.key + '_picker"]');
        dp.datepicker('setDate', value);
    },
    getValue : function () {
        var self = this;
        return $(self.container).find(self.control_selector).val();
    }
});